import { useApiStore } from './api.ts'
import { defineStore } from 'pinia'

export const useAlimentationStore = defineStore('alimentation', {
  state: () => ({
    api: useApiStore(),
    historique: null,
    nouveauRepas: {
      date: '',
      time: '',
      lait: {
        laitMaternel: 0,
        laitPoudre: 0,
        laitAnimal: 0,
        vomi: 0
      },
      allaitement: {
        sg: false,
        sd: false
      },
      aliments: [],
    },
    // nouveauRepas: {
    //   valid: false,
    //   date: '',
    //   time: '',
    //   enfant: 'Lucie',
    //   sg: false,
    //   sd: false,
    //   lmt: 0,
    //   pre: 0,
    //   vomi: 0,
    // },
    listeAnnees: [],
    listeMois: [],
    selectionAnnee: null,
    selectionMois: null
  }),
  actions: {
    async getHistoriqueAlimentation () {
      const alimentationData = await this.api.get(`/repas/`)
      this.historique = alimentationData.data
      
      this.listeAnnees = Object.keys(alimentationData.data)
    },
    async sauvegardeRepas() {
      const repas = await this.api.post(`/repas/`, {
        date: this.nouveauRepas.date,
        enfant: this.nouveauRepas.enfant,
        sg: this.nouveauRepas.sg,
        sd: this.nouveauRepas.sd,
        lmt: this.nouveauRepas.lmt,
        pre: this.nouveauRepas.pre,
        vomi: this.nouveauRepas.vomi,
      })

      console.log(repas)

    },
    choixAnnee(annee) {
      this.selectionAnnee = annee
      this.listeMois = Object.keys(this.historique[annee])
    },
    choixMois(mois) {
      this.selectionMois = mois
    },
    async suppressionRepas(id) {
      console.log(`ID: ${id}`)
      // const repas = await this.api.delete(`/alimentation/`, {
      //   id: id
      // })
      // console.log(repas)

    }
  }
})